import script from "./reviewProposalModal.vue?vue&type=script&setup=true&lang=js"
export * from "./reviewProposalModal.vue?vue&type=script&setup=true&lang=js"

import "./reviewProposalModal.vue?vue&type=style&index=0&id=b833d902&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b833d902"]])

export default __exports__